export const fallbackAdminRoutes = [
  {
    path: "*",
    layout: false,
    component: "./NotFoundPage",
  },
];
